import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=ffc48fa4&scoped=true&"
import script from "./Feed.vue?vue&type=script&lang=ts&"
export * from "./Feed.vue?vue&type=script&lang=ts&"
import style0 from "./Feed.vue?vue&type=style&index=0&id=ffc48fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc48fa4",
  null
  
)

export default component.exports